<template>
  <div class="about">
  </div>
</template>

<script>

import Community from '@/services/Community.js'

export default {
  name: 'About',
  props: {
  },
  data (){
    return {
    }
  },
  created() {
    console.log('tt')
    Community.check();

  },
  methods: {
  }
}

</script>